/**
 * Адреса раздела «Смена»:
 *
 * - `/shift`, `/shift/checklists?date=` — чек-листы дня; `/shift/checklists/12` — прохождение;
 * - `/shift/tasks`, `/shift/tasks/34` — доска и карточка задачи (ссылка из «Сегодня»);
 * - `/shift/timesheet?period=week|month|quarter` — табель;
 * - `/shift/templates`, `/shift/templates/5` — шаблоны и редактор;
 * - `/shift/discipline?from=&to=` — дисциплина.
 */

export type ShiftTab = 'checklists' | 'tasks' | 'timesheet' | 'templates' | 'discipline';

export const SHIFT_TABS: ShiftTab[] = ['checklists', 'tasks', 'timesheet', 'templates', 'discipline'];

export interface ShiftRoute {
  /** `null` — «/shift» без вкладки: открывается первая доступная. */
  tab: ShiftTab | null;
  id: number | null;
}

export function readShift(path: string): ShiftRoute {
  const match = /^\/shift(?:\/([a-z]+))?(?:\/(\d+))?$/.exec(path);
  if (!match || !match[1]) return { tab: null, id: null };
  const tab = SHIFT_TABS.find((item) => item === match[1]) ?? null;
  return { tab, id: tab && match[2] ? Number(match[2]) : null };
}

export function tabPath(tab: ShiftTab, id?: number): string {
  return id === undefined ? `/shift/${tab}` : `/shift/${tab}/${id}`;
}
